module.exports = __webpack_public_path__ + "img/xlsx.db4869c6.svg";